import enMessage from "../bbui/i18n/en";
export default enMessage;
